
import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { static_options } from '../lib/options';
import { namespace } from 'vuex-class';
import moment from 'moment';
import { filterOption } from '../lib/form_struct';
import BatchModifying from './batch-modifying.vue';

const Hundun = namespace('Hundun');
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  edit_recruiting_batch: `${FCAPI}/boss/hundun/chuang/recruiting/batch/0`,
  user_define: `${FCAPI}/boss/hundun/chuang/custom/`,
  delete_tag: `${FCAPI}/boss/hundun/user/tag`,
  edit_user_detail: `${FCAPI}/boss/hundun/user/attribute`
};
@Component({
  components: { BatchModifying }
})
export default class MissionDetail extends Vue {
  /* eslint-disable */
  @Hundun.State('teacher_list') teacher_list!: any[]; //负责班主任
  @Hundun.State('tag_list') tag_list: any; //标签
  @Prop({ default: () => [] }) data_list!: Array<any>;
  @Prop({ default: () => [] }) user_define_list!: Array<any>;
  @Prop({ default: () => [] }) pagenation_info!: any;

  @Inject('getTableList')
  getTableList: any;
  file_list: any;
  select_row_key = [];
  // pagenation_info = { current: 0, limit: 0, total: 0 };
  filterOption = filterOption;
  static_options = static_options;
  select_tag_id = 0;
  dialog_form_list = [] as any;
  modifying_dialog_visible = false;
  window = window as any;
  is_show_user_detail = false;
  record = {} as any;
  show_text_modal = false;
  text = '';
  // 翻页
  paginationOption() {
    return {
      current: this.pagenation_info.current || 0,
      total: this.pagenation_info.total || 0,
      pageSize: this.pagenation_info.limit || 0,
      showTotal: () => `共${this.pagenation_info.total}条，每页${this.pagenation_info.limit}条`
    };
  }

  //添加标签
  addTag(record: any, type: number) {
    this.select_tag_id = record.user_id;
    this.dialog_form_list = [
      {
        tag_name: 'a-cascader',
        key: 'tag',
        label: '标签',
        value: undefined,
        bind: {
          options: this.tag_list.filter((item: any) => item.type == type),
          fieldNames: { label: 'tag_name', value: 'id', children: 'parent' },
          changeOnSelect: true,
          placeholder: '请选择'
        }
      }
    ];
    this.modifying_dialog_visible = true;
  }

  //删除标签
  async deleteTag(id: number) {
    const res: any = await this.$axios.delete(`${API.delete_tag}/${id}`);
    if (res.status == 200) {
      this.$message.success('删除成功');
      // this.getSeedingList(this.table_data.current);
      return;
    }
  }
  async handleOk(list: any, type: number) {
    console.log(123);
    const tag = list.find((item: any) => item.key == 'tag')?.value || undefined;
    const send_data = {
      column: 'tag',
      value: tag ? tag[tag.length - 1] : undefined
    };
    const res = await this.$axios.put(`${API.edit_user_detail}/${this.select_tag_id}?menu_id=${(window as any).route_menu_id}`, send_data);
    console.log(res);

    if (res.status !== 200 || res.data.status !== 200) return this.$message.error('编辑失败!');
    this.$message.success('编辑成功！');
    this.modifying_dialog_visible = false;
    this.getTableList();
  }
  handleCancel() {
    this.modifying_dialog_visible = false;
    this.dialog_form_list.forEach((item: any) => (item.value = undefined));
    // this.$forceUpdate();
  }
  // 多选
  onSelectChange(select_row_key: any) {
    this.select_row_key = select_row_key;
    this.$emit('selectChange', select_row_key);
  }

  // 自定义字段编辑
  async userDefineTableValue(item: any, id: number) {
    // if (!item.custom_value) return;
    const res = await this.$axios.put(`${API.user_define}${id}`, item);
    if (res.data.status !== 200) return this.$message.error('编辑失败！');
    this.$message.success('编辑成功！');
    this.getTableList();
  }

  // 表格编辑
  async editTableValue(val: any, type: string, id: number) {
    const charger_name = [] as any[];
    // if (!val || val.length == 0) return;
    if (type == 'time' || type == 'interview_time' || type == 'fee_time') val = moment(val).unix() || 0;
    if (type == 'source') val = val.join(',');
    if (type == 'charger_id') {
      val.forEach((element: any) => {
        this.teacher_list.forEach((item: any) => {
          if (item.id == element) charger_name.push(item.weixin_nickname);
        });
      });
      val = val.join(',');
    }

    const send_data = { id: [id], [type]: val, charger_name: charger_name.length == 0 ? undefined : charger_name.join(','), cover_level: 1 };

    await this.$axios.put(`${API.edit_recruiting_batch}`, send_data);
    this.$message.success('编辑成功！');
    this.getTableList(this.pagenation_info.current);
  }
  // 切换分页
  async changePage(page: any) {
    this.pagenation_info.current = page.current;
    this.getTableList(page.current);
  }
  // 手机号
  formatMobile = (phone: any) => {
    const reg = /^(\d{3})\d{4}(\d{4})$/;
    phone = phone.toString().replace(reg, '$1****$2');
    return phone;
  };
  editModal(record: any) {
    this.record = record;
    this.text = record.chuang_user.followup;
    this.show_text_modal = true;
  };
  confirmEdit() {
    this.editTableValue(this.text, 'followup', this.record.id)
    this.show_text_modal = false;
  }
}
